import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=32bb7f22&scoped=true"
import script from "./FileUpload.vue?vue&type=script&lang=js"
export * from "./FileUpload.vue?vue&type=script&lang=js"
import style0 from "./FileUpload.vue?vue&type=style&index=0&id=32bb7f22&prod&scoped=true&lang=css"
import style1 from "./FileUpload.vue?vue&type=style&index=1&id=32bb7f22&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bb7f22",
  null
  
)

export default component.exports